import ApiService from "@/services/api.service";
import getters from "@/store/global";

const state = {
    puzzles: [],
    count: "",
    next: "",
    pageSize: 10,
    selected: [],
    details: {},
    errors: {},
    description: "",
};

getters["fetchMyPuzzles"] = function (state) {
    return state.puzzles;
};
getters["fetchMyPuzzlesDetails"] = function (state) {
    return state.details;
};
getters["fetchMyPuzzlesNext"] = function (state) {
    return state.next;
};
getters["fetchMyPuzzlesCount"] = function (state) {
    return state.count;
};
getters["fetchMyPuzzlesSelected"] = function (state) {
    return state.selected;
};

const actions = {
    get(context) {
        return ApiService.get("puzzles/my/")
            .then((response) => {
                context.commit("SET_ERROR", {});
                context.commit("SET_PUZZLES", response.data.results);
                context.commit("SET_COUNT", response.data.count);
                context.commit("SET_NEXT", response.data);
                context.commit("SET_PAGE_SIZE", response.data.page_size);
            })
            .catch(() => {
                throw new Error("Something goes wrong");
            });
    },
    getDetails(context, payload) {
        return ApiService.get("puzzles/" + payload + "/")
            .then((response) => {
                context.commit("SET_ERROR", {});
                context.commit("SET_DETAILS", response.data);
            })
            .catch((response) => {
                context.commit("SET_ERROR", response.data);
                throw new Error("Something goes wrong");
            });
    },
    getNext(context) {
        return ApiService.get(context.state.next)
            .then((response) => {
                context.commit("SET_ERROR", {});
                context.commit("ADD_PUZZLES", response.data.results);
                context.commit("SET_NEXT", response.data);
            })
            .catch((response) => {
                context.commit("SET_ERROR", response.data);
                throw new Error("Something goes wrong");
            });
    },
    create(context, payload) {
        return ApiService.post("puzzles/create/", payload)
            .then((response) => {
                context.commit("SET_ERROR", {});
                context.commit("ADD_NEW_PUZZLE", response.data[0]);
                context.commit("SET_DESCRIPTION", payload.description);
            })
            .catch((response) => {
                context.commit("SET_ERROR", response.data);
                throw new Error("Something goes wrong");
            });
    },
    // updateDescription(context, payload) {
    //     return ApiService
    //         .patch('puzzles/update/', payload)
    //         .then(() => {
    //             context.commit('SET_ERROR', {});
    //         })
    //         .catch((response) => {
    //             context.commit('SET_ERROR', response.data);
    //             throw new Error('Something goes wrong');
    //         });
    // },
    updateDescription(context, payload) {
        return ApiService.patch("photos/update/", payload)
            .then(() => {
                context.commit("SET_ERROR", {});
            })
            .catch((response) => {
                context.commit("SET_ERROR", response.data);
                throw new Error("Something goes wrong");
            });
    },
    delete(context, payload) {
        return ApiService.put("photos/remove/", payload)
            .then((response) => {
                context.commit("SET_ERROR", {});
                context.commit("REMOVE_PUZZLES", payload);
            })
            .catch((response) => {
                context.commit("SET_ERROR", response.data);
                throw new Error("Something goes wrong");
            });
    },
    select(context, payload) {
        context.commit("SELECT_PUZZLE", payload);
    },
    clearSelected(context) {
        context.commit("CLEAR_SELECTED");
    },
};

const mutations = {
    SET_PUZZLES(state, puzzles) {
        state.puzzles = puzzles;
        state.errors = {};
    },
    SET_DETAILS(state, details) {
        state.details = details;
        state.errors = {};
    },
    ADD_PUZZLES(state, puzzles) {
        state.puzzles = state.puzzles.concat(puzzles);
        state.errors = {};
    },
    ADD_NEW_PUZZLE(state, puzzle) {
        state.count++;
        if (state.puzzles.length > state.pageSize) {
            state.puzzles.pop();
        }
        state.puzzles.unshift(puzzle);
        state.errors = {};
    },
    REMOVE_PUZZLES(state, puzzles) {
        let temp = state.puzzles.slice(0);
        state.puzzles = [];
        for (let i in temp) {
            if (puzzles.indexOf(temp[i].id) == -1) {
                state.puzzles.push(temp[i]);
            }
        }
        state.count -= puzzles.length;
        state.next = "";
        state.selected = [];
        state.errors = {};
    },
    SET_COUNT(state, count) {
        state.count = count;
        state.errors = {};
    },
    SET_NEXT(state, data) {
        if (data.page < data.num_pages) {
            state.next =
                data.url + "?" + data.page_param + "=" + (data.page + 1);
        } else {
            state.next = "";
        }
        state.errors = {};
    },
    SET_PAGE_SIZE(state, pageSize) {
        state.pageSize = pageSize;
    },
    SELECT_PUZZLE(state, id) {
        if (state.selected.indexOf(id) == -1) {
            state.selected.push(id);
        } else {
            state.selected.splice(state.selected.indexOf(id), 1);
        }
    },
    SET_ERROR(state, errors) {
        state.errors = errors;
    },
    SET_DESCRIPTION(state, description) {
        state.description = description;
        state.errors = {};
    },
    CLEAR_SELECTED(state) {
        state.selected = [];
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
